import { createRouter, createWebHistory } from "vue-router";
import Home from "@/pages/Home.vue";
import Company from "@/pages/Company.vue";
import OurWorks from "@/pages/OurWorks.vue";
import WorksDetail from "@/pages/Works-Detail.vue";
import Services from "@/pages/Services.vue";
import TVCommercialVideo from "@/pages/Services/TVCommercialVideo.vue";
import CompanyProfile from "@/pages/Services/CompanyProfile.vue";
import AnimationVideo from "@/pages/Services/AnimationVideo.vue";
import CampaignVideo from "@/pages/Services/CampaignVideo.vue";
import ContactUs from "@/pages/ContactUs.vue";
import ComingSoon from "@/pages/ComingSoon.vue";

const DEFAULT_TITLE = "SmilePictures";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home — SmilePictures",
    },
  },
  {
    path: "/company",
    name: "Company",
    component: Company,
    meta: {
      title: "Company — SmilePictures",
    },
  },
  {
    path: "/works",
    name: "Our Works",
    component: OurWorks,
    meta: {
      title: "Our Works — SmilePictures",
    },
  },
  {
    path: "/works/:slug",
    name: "Works Detail",
    component: WorksDetail,
    meta: {
      title: "Work Detail — SmilePictures",
    },
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    meta: {
      title: "Services — SmilePictures",
    },
  },
  {
    path: "/services/tv-commercial",
    name: "TV Commercial Video",
    component: TVCommercialVideo,
    meta: {
      title: "TV Commercial Video — SmilePictures",
    },
  },
  {
    path: "/services/company-profile",
    name: "Company Profile",
    component: CompanyProfile,
    meta: {
      title: "Company Profile — SmilePictures",
    },
  },
  {
    path: "/services/video-animation",
    name: "Animation Video",
    component: AnimationVideo,
    meta: {
      title: "Animation Video — SmilePictures",
    },
  },
  {
    path: "/services/video-campaigns",
    name: "Campaign Video",
    component: CampaignVideo,
    meta: {
      title: "Campaign Video — SmilePictures",
    },
  },
  {
    path: "/contact",
    name: "Contact Us",
    component: ContactUs,
    meta: {
      title: "Contact Us — SmilePictures",
    },
  },
  {
    path: "/coming-soon",
    name: "Coming Soon",
    component: ComingSoon,
    meta: {
      title: "Coming Soon — SmilePictures",
      hideNavbar: true,
      hideCTA: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});

export default router;
